export default () => ({
    desktopPlacement: {
        type: String,
        default: 'row_*',
    },

    mobilePlacement: {
        type: String,
        default: 'row_1',
    },

    uspPlacement: {
        type: String,
        default: 'none',
    },

    textBtn: {
        type: String,
        default: 'Получить деньги',
    },
});